<p-message
    [dt]="pMessageScopedToken"
    severity="warn"
    variant="text"
    class="text-center"
    styleClass="w-full text-center !rounded-none !py-0">
    <ng-template #container>
        <div
            class="flex min-h-8 w-full items-center justify-center px-2 text-sm font-medium leading-normal">
            <div>
                <span aria-hidden="true">🌼📢 </span>
                <span class="font-semibold"
                    >Group Sessions are going live on Monday, Aug 10th!</span
                >
                <span aria-hidden="true"> · </span>
                <button
                    type="button"
                    class="cursor-pointer underline underline-offset-2 hover:no-underline"
                    (click)="onClickLearnMore()">
                    Learn more
                </button>
            </div>
        </div>
    </ng-template>
</p-message>
